export const US_AUTOSHIP_MAX_SAVINGS = '$20';
export const CA_AUTOSHIP_MAX_SAVINGS = '$30';
export const AUTOSHIP_FREE_SHIPPING_THRESHOLD = '$49';
export const AUTOSHIP_RECURRING_ORDERS_DISCOUNT = '5%';

export const US_AUTOSHIP_MAX_SAVINGS_VALUE = 20;
export const CA_AUTOSHIP_MAX_SAVINGS_VALUE = 30;
export const AUTOSHIP_RECURRING_ORDERS_DISCOUNT_VALUE = 5;
